// ═══════════════════════════════════════════════════════════════════════════
// 📊 CATEGORY DISTRIBUTION BAR - Barra verde con pallini stile Big Tech
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';

/**
 * Barra di distribuzione con segmenti verdi e legenda con pallini
 * Layout identico alla vista Foto esistente
 *
 * @param {Object} data - Oggetto { "Categoria": count, ... }
 * @param {string} type - "ricordi" | "foto"
 */
function CategoryDistributionBar({ data, type = 'ricordi' }) {
  // Calcola totale
  const total = Object.values(data).reduce((a, b) => a + b, 0);

  if (total === 0) {
    return (
      <div style={styles.container}>
        <h3 style={styles.title}>Distribuzione {type} per categoria</h3>
        <p style={styles.empty}>Nessun elemento da mostrare</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Titolo */}
      <h3 style={styles.title}>Distribuzione {type} per categoria</h3>

      {/* Barra verde con segmenti */}
      <div style={styles.bar}>
        {Object.entries(data).map(([cat, count], index) => (
          <div
            key={cat}
            style={{
              ...styles.segment,
              width: `${(count / total) * 100}%`,
              borderRight: index < Object.keys(data).length - 1 ? '1px solid white' : 'none',
            }}
            title={`${cat}: ${count} ${type} (${((count / total) * 100).toFixed(1)}%)`}
          />
        ))}
      </div>

      {/* Legenda con pallini verdi */}
      <div style={styles.legend}>
        {Object.entries(data).map(([cat, count]) => (
          <div key={cat} style={styles.legendItem}>
            <span style={styles.dot} />
            <span style={styles.label}>{cat}</span>
            <span style={styles.count}>{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 STYLES - Big Tech Minimal Design
// ═══════════════════════════════════════════════════════════════════════════

const styles = {
  container: {
    marginBottom: '32px',
  },

  title: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#404040',
    marginBottom: '12px',
    textTransform: 'none',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  bar: {
    height: '8px',
    borderRadius: '4px',
    background: '#E5E5E5',
    display: 'flex',
    overflow: 'hidden',
    marginBottom: '16px',
  },

  segment: {
    background: '#22C55E',
    transition: 'all 200ms',
  },

  legend: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
  },

  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#22C55E',
    flexShrink: 0,
  },

  label: {
    color: '#525252',
    fontWeight: 500,
  },

  count: {
    color: '#A3A3A3',
    fontWeight: 400,
  },

  empty: {
    fontSize: '14px',
    color: '#A3A3A3',
    fontStyle: 'italic',
    padding: '16px 0',
  },
};

export default CategoryDistributionBar;
